import ApiService from "../api";
import ValidationError from '../exception/ValidationError';

export default class NpsService extends ApiService {

    constructor() {
        super('/api/nps')
    }

    findById(id) {
        return this.get(`/${id}`)
    }

    findAll(filter, pageSize, page) {
        let params = `?size=${pageSize}&page=${page}&sort=id,asc`

        if (filter.startDate) {
            params = `${params}&startDate=${filter.startDate}`
        }

        if (filter.endDate) {
            params = `${params}&endDate=${filter.endDate}`
        }

        if (filter.employeeName) {
            params = `${params}&employeeName=${filter.employeeName}`
        }

        if (filter.date) {
            params = `${params}&date=${filter.date}`
        }

        if (filter.orderId) {
            params = `${params}&orderId=${filter.orderId.replaceAll("/", "").replaceAll("-", "").replaceAll(" ", "")}`
        }

        if (filter.romaneioId) {
            params = `${params}&romaneioId=${filter.romaneioId.replaceAll("/", "").replaceAll("-", "").replaceAll(" ", "")}`
        }

        if (filter.clientCode) {
            params = `${params}&clientCode=${filter.clientCode.replaceAll("/", "").replaceAll("-", "").replaceAll(" ", "")}`
        }

        if (filter.driverName) {
            params = `${params}&driverName=${filter.driverName}`
        }

        if (filter.driverId) {
            params = `${params}&driverId=${filter.driverId}`
        }

        if (filter.branchId) {
            params = `${params}&branchId=${filter.branchId}`
        }

        if (filter.branchCode) {
            params = `${params}&branchCode=${filter.branchCode}`
        }

        return this.get(`${params}`,);
    }

    exportExcel(filter) {
        let params = `/export-excel?`

        if (filter.startDate) {
            params = `${params}&startDate=${filter.startDate}`
        }

        if (filter.endDate) {
            params = `${params}&endDate=${filter.endDate}`
        }

        if (filter.employeeName) {
            params = `${params}&employeeName=${filter.employeeName}`
        }

        if (filter.date) {
            params = `${params}&date=${filter.date}`
        }

        if (filter.orderId) {
            params = `${params}&orderId=${filter.orderId.replaceAll("/", "").replaceAll("-", "").replaceAll(" ", "")}`
        }

        if (filter.romaneioId) {
            params = `${params}&romaneioId=${filter.romaneioId.replaceAll("/", "").replaceAll("-", "").replaceAll(" ", "")}`
        }

        if (filter.clientCode) {
            params = `${params}&clientCode=${filter.clientCode.replaceAll("/", "").replaceAll("-", "").replaceAll(" ", "")}`
        }

        if (filter.driverName) {
            params = `${params}&driverName=${filter.driverName}`
        }

        if (filter.driverId) {
            params = `${params}&driverId=${filter.driverId}`
        }

        if (filter.branchId) {
            params = `${params}&branchId=${filter.branchId}`
        }

        if (filter.branchCode) {
            params = `${params}&branchCode=${filter.branchCode}`
        }

        return this.getFile(`${params}`,);
    }

    create(data) {
        return this.post(`/`, data)
    }

    update(id, data) {
        return this.put(`/${id}`, data)
    }

    del(id, employeeId) {
        return this.delete(`/${id}/${employeeId}`)
    }

    getDashboard(params) {
        let filter = `?startDate=${params.startDate}&endDate=${params.endDate}`;
        if (params.branchId) {
            filter += `&branchId=${params.branchId}`;
        }
        if (params.driverId) {
            filter += `&driverId=${params.driverId}`;
        }
        return this.get(`/dashboard/${filter}`);
    }

    getEvolucao(params) {
        let filter = `?startDate=${params.startDate}&endDate=${params.endDate}`;
        if (params.branchId) {
            filter += `&branchId=${params.branchId}`;
        }
        if (params.driverId) {
            filter += `&driverId=${params.driverId}`;
        }
        return this.get(`/evolucao/${filter}`);
    }

    getMediaPorCriterio(params) {
        let filter = `?startDate=${params.startDate}&endDate=${params.endDate}`;
        if (params.branchId) {
            filter += `&branchId=${params.branchId}`;
        }
        if (params.driverId) {
            filter += `&driverId=${params.driverId}`;
        }
        return this.get(`/avaliacao-criterios/${filter}`);
    }

    getPorDia(params) {
        let filter = `?startDate=${params.startDate}&endDate=${params.endDate}`;
        if (params.branchId) {
            filter += `&branchId=${params.branchId}`;
        }
        if (params.driverId) {
            filter += `&driverId=${params.driverId}`;
        }
        return this.get(`/por-dia${filter}`);
    }

    getPorMotorista(params) {
        let filter = `?startDate=${params.startDate}&endDate=${params.endDate}`;
        if (params.branchId) {
            filter += `&branchId=${params.branchId}`;
        }
        if (params.driverId) {
            filter += `&driverId=${params.driverId}`;
        }
        return this.get(`/drivers${filter}`);
    }

    getMotoristasSemNps(params) {
        let filter = `?startDate=${params.startDate}&endDate=${params.endDate}`;
        if (params.branchId) {
            filter += `&branchId=${params.branchId}`;
        }
        if (params.driverId) {
            filter += `&driverId=${params.driverId}`;
        }
        return this.get(`/motoristas-sem-nps${filter}`);
    }

      getPorAjudante(params) {
        let filter = `?startDate=${params.startDate}&endDate=${params.endDate}`;
        
        if (params.branchId) {
            filter += `&branchId=${params.branchId}`;
        }
     
        return this.get(`/assistants${filter}`);
    }


    validate(formik) {
        const errors = [];

        if (!formik.clientCode) {
            errors.push("Informe o Código do Cliente.")
        }

        if (!formik.orderId) {
            errors.push("Informe o número do Pedido.")
        }
        if (formik.teamApproach === null) {
            errors.push("Informe a nota para Abordagem de equipe.")
        }
        if (formik.storageCheck === null) {
            errors.push("Informe a nota para Armazenamento e Conferência.")
        }
        if (formik.productQuality === null) {
            errors.push("Informe a nota para Qualidade dos Produtos.")
        }
        if (formik.issueResolution === null) {
            errors.push("Informe a nota para Resolução de Avarias e Faltas.")
        }
        if (formik.deliveryTime === null) {
            errors.push("Informe a nota para Prazo e Horário de Entrega.")
        }
        if (formik.npsScore == null) {
            errors.push("Informe a nota para Nosso Serviço.")
        }
        if (!formik.finalNotes) {
            errors.push("Informe a Observação Final.")
        }
        if (errors && errors.length > 0) {
            throw new ValidationError(errors);
        }
    }

}